import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withKeys as _withKeys, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  style: {
    "line-height": "36px"
  }
};
const _hoisted_2 = {
  key: 10,
  style: {
    "color": "red",
    "min-width": "100px"
  }
};
import { dictionary } from "@/utils/dynamicDic";
import { getCityProvice } from "@/api/common";
import searchDicFcs from "@/api/searchDynamicDic";
import exportFunctions from "@/api/exportList";
import levelFcs from "@/api/levelChageList.js";
import { getCurrentInstance, onMounted } from "vue";
export default {
  __name: 'hSearchForm',
  props: {
    searchItems: {
      type: Object,
      default: () => ({})
    },
    buttons: {
      type: Array,
      default: () => []
    },
    isExport: {
      type: Boolean,
      default: false
    },
    exportMethod: {
      type: String,
      default: ""
    },
    searchTitle: {
      type: String,
      default: ""
    },
    labelWidth: {
      type: String,
      default: "120px"
    },
    needFirstSearh: {
      type: Boolean,
      default: true
    }
  },
  emits: ["emitButtonKey", "handleSearch", "sendHeight"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    // import Bus from "@/utils/bus";
    // import InputRange from '@/components/InputRange'
    const props = __props;
    const {
      proxy
    } = getCurrentInstance();
    const emit = __emit;
    let isShowForm = ref(true);
    let queryParams = ref({});
    let levelData = ref({});
    let dynamicHei = ref("");
    // 用于跟踪导航栏是否应该固定
    const isSticky = ref(false);

    // 滚动处理函数
    const handleScroll = () => {
      // 当滚动距离超过100px时，导航栏固定
      // 您可以根据需要调整这个阈值
      isSticky.value = window.scrollY > 90;
    };
    const searchBtnText = computed(() => {
      const msg = isShowForm.value ? "隐藏查询条件" : "展示查询条件";
      return msg;
    });
    initDic();
    onMounted(() => {
      // window.addEventListener("scroll", handleScroll);
      if (props.needFirstSearh) {
        setTimeout(() => {
          emit("handleSearch", queryParams.value, true);
        }, 100);
      }
      dynamicHei.value = getCardHeight();
      emit("sendHeight", dynamicHei.value);
    });
    function getCardHeight() {
      const card = document.getElementById("el-card");
      return card.getBoundingClientRect().height + "px";
    }
    // 卸载时移除滚动监听，防止内存泄漏
    onUnmounted(() => {
      // window.removeEventListener("scroll", handleScroll);
    });
    function changFormStatus() {
      isShowForm.value = !isShowForm.value;
    }
    // 多级联动存储数据
    let cascaderOptions = ref([]);
    function getLevelData(item) {
      return function (node, resolve) {
        const {
          level
        } = node;
        const leafCap = item.leafLength ?? 2;
        const rootParent = item.defaultLevVal !== undefined && item.defaultLevVal !== null ? item.defaultLevVal : item.params?.parentId;
        const parentId = node.value !== undefined && node.value !== null && node.value !== "" ? node.value : rootParent ?? 1;
        levelFcs[item.api]({
          ...(item.params || {}),
          parentId
        }).then(res => {
          const ok = res.code == 200 || res.success === true;
          if (!ok) {
            resolve([]);
            return;
          }
          const raw = res.data;
          const list = Array.isArray(raw) ? raw : raw?.records || raw?.list || [];
          const nodes = list.map(city => ({
            value: city.id ?? city.areaId,
            label: city.areaName ?? city.name ?? city.label ?? "-",
            leaf: !!(level >= leafCap || city.leaf === true || city.isLeaf === true)
          }));
          resolve(nodes);
        }).catch(() => resolve([]));
      };
    }

    // 初始化数据
    function initDic() {
      props.searchItems.forEach(async item => {
        if (item.dicCode) {
          item.dicCodeData = await dictionary.getValuesByName(item.dicCode);
        }
        if (item.type == "yearPicker" && item.aliasFcName) {
          // 部分字典数据是单独的接口，需要单独处理
          if (item.defaultVal) {
            // 如果存在默认值，需要调用联动接口，获取联动数据
            searchDicFcs[item.aliasFcName](item.aliasParams).then(levelRes => {
              if (levelRes.data?.length > 0) {
                levelData.value[item.aliasDataCode] = levelRes.data.map(litem => ({
                  label: litem[item.aliasOriLabel],
                  value: litem[item.aliasOriVal]
                }));
              } else {
                levelData.value[item.aliasDataCode] = [];
              }
            });
          }
        }
        if (item.fcName) {
          try {
            const res = await searchDicFcs[item.fcName](item.params);
            const ok = res.code == 200 || res.success === true;
            if (ok && res.data != null) {
              const raw = res.data;
              const list = Array.isArray(raw) ? raw : raw.records || raw.list || [];
              item.dicCodeData = list.map(row => ({
                ...row,
                value: row.roleId ?? row.id,
                label: row.roleName ?? row.name ?? "-"
              }));
            }
          } catch (e) {
            console.error("[hSearchForm] fcName:", item.fcName, e);
          }
        }
        if (item.defaultVal) {
          queryParams.value[item.code] = item.defaultVal;
        }
        //else {
        // queryParams.value[item.code] = "";
        //}
        // 如果是省份
        if (item.proCode) {
          const res = await getCityProvice(item.proCode);
          if (res.code == 200) {
            item.dicCodeData = res.data;
          }
        }
      });
    }
    function emitMethod(key) {
      emit("emitButtonKey", {
        key
      });
    }

    // 设置搜索参数初始值
    function setParamInitVal(initVal) {
      if (initVal && initVal.length > 0) {
        initVal.forEach(item => {
          queryParams.value[item.key] = item.value;
        });
      }
    }
    function getParamBykey(code) {
      return queryParams.value[code];
    }
    // 导出数据
    function exportData(params) {
      proxy.zxDownload(exportFunctions[props.exportMethod], params);
    }

    // 重置表单
    function reset() {
      queryParams.value = {};
      // Bus.$emit('clearInputRange')
      emit("handleSearch", queryParams.value, true, true);
    }
    // 抛出查询参数
    function getList() {
      console.log("queryParams.value", queryParams.value);
      proxy.$refs.dynamicValidateForm.validate(valid => {
        if (valid) {
          emit("handleSearch", queryParams.value, true);
        } else {
          return false;
        }
      });
    }
    __expose({
      setParamInitVal,
      exportData,
      getParamBykey
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createElementBlock("div", {
        style: _normalizeStyle({
          'min-height': _unref(isShowForm) ? _unref(dynamicHei) : '50px',
          position: 'relative'
        })
      }, [_unref(isShowForm) ? (_openBlock(), _createBlock(_component_el_card, {
        key: 0,
        class: _normalizeClass(['h-card']),
        shadow: "never",
        style: {
          top: '0px',
          'z-index': 999
        },
        id: "el-card"
      }, {
        header: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("i", {
              class: "el-icon-date"
            }, null, -1)), _createTextVNode(" " + _toDisplayString(__props.searchTitle || "筛选查询"), 1)])]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12,
            style: {
              "text-align": "right"
            }
          }, {
            default: _withCtx(() => [false ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              size: "default",
              icon: "Refresh",
              onClick: reset
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("重置", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true), __props.isExport ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              size: "default",
              type: "primary",
              icon: "Download",
              onClick: _cache[0] || (_cache[0] = $event => emitMethod('export'))
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("导出", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true), false ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              size: "default",
              type: "primary",
              icon: _unref(isShowForm) ? 'ZoomOut' : 'ZoomIn',
              onClick: changFormStatus
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(searchBtnText)), 1)]),
              _: 1
            }, 8, ["icon"])) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives(_createVNode(_component_el_form, {
          ref: "dynamicValidateForm",
          model: _unref(queryParams),
          "label-position": "right",
          "label-width": __props.labelWidth,
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 24
          }, {
            default: _withCtx(() => [_renderSlot(_ctx.$slots, "default"), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.searchItems, (item, index) => {
              return _openBlock(), _createBlock(_component_el_col, {
                span: item.col || 6,
                key: index
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: item.name + ':',
                  rules: item.rules,
                  "label-width": item.labelWidth || __props.labelWidth,
                  prop: item.code
                }, {
                  default: _withCtx(() => [item.type === 'input' ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    modelValue: _unref(queryParams)[item.code],
                    "onUpdate:modelValue": $event => _unref(queryParams)[item.code] = $event,
                    modelModifiers: {
                      trim: true
                    },
                    placeholder: item.placeholder || '请输入',
                    onKeyup: _withKeys(getList, ["enter"]),
                    disabled: item.disabled,
                    clearable: "",
                    style: {
                      "min-width": "100px"
                    }
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"])) : _createCommentVNode("", true), item.type === 'inputNumber' ? (_openBlock(), _createBlock(_component_el_input_number, {
                    key: 1,
                    modelValue: _unref(queryParams)[item.code],
                    "onUpdate:modelValue": $event => _unref(queryParams)[item.code] = $event,
                    modelModifiers: {
                      trim: true
                    },
                    "step-strictly": "",
                    style: {
                      "min-width": "120px"
                    }
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])) : item.type === 'singleSelect' && item.enum ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 2,
                    placeholder: "请选择",
                    modelValue: _unref(queryParams)[item.code],
                    "onUpdate:modelValue": $event => _unref(queryParams)[item.code] = $event,
                    disabled: item.disabled,
                    multiple: item.multiple,
                    clearable: "",
                    style: {
                      "min-width": "100px"
                    }
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.enum, enumItem => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: enumItem.value,
                        label: enumItem.label,
                        value: enumItem.value,
                        disabled: item.disabled
                      }, null, 8, ["label", "value", "disabled"]);
                    }), 128))]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "multiple"])) : item.type === 'cascader' ? (_openBlock(), _createBlock(_component_el_cascader, {
                    key: 3,
                    modelValue: _unref(queryParams)[item.code],
                    "onUpdate:modelValue": $event => _unref(queryParams)[item.code] = $event,
                    placeholder: item.placeholder || '',
                    options: _unref(cascaderOptions),
                    debounce: 300,
                    props: {
                      multiple: item.multiple,
                      lazy: true,
                      lazyLoad: getLevelData(item),
                      checkStrictly: item.props?.checkStrictly || false
                    },
                    clearable: "",
                    style: {
                      "min-width": "100px"
                    },
                    filterable: item.filterable
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "options", "props", "filterable"])) : item.type === 'singleSelect' && item.proCode ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 4,
                    placeholder: "请选择",
                    modelValue: _unref(queryParams)[item.code],
                    "onUpdate:modelValue": $event => _unref(queryParams)[item.code] = $event,
                    disabled: item.disabled,
                    clearable: "",
                    style: {
                      "min-width": "100px"
                    }
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.dicCodeData, dicItem => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: dicItem.id,
                        label: dicItem.areaName,
                        value: dicItem.id
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : item.type === 'singleSelect' && item.fc ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 5,
                    placeholder: "请选择",
                    modelValue: _unref(queryParams)[item.code],
                    "onUpdate:modelValue": $event => _unref(queryParams)[item.code] = $event,
                    disabled: item.disabled,
                    clearable: "",
                    style: {
                      "min-width": "100px"
                    }
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.dicCodeData, dicItem => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: dicItem.id,
                        label: dicItem.areaName,
                        value: dicItem.id
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : item.type === 'singleSelect' && item.dataCode ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 6,
                    placeholder: "请选择选项",
                    modelValue: _unref(queryParams)[item.code],
                    "onUpdate:modelValue": $event => _unref(queryParams)[item.code] = $event,
                    disabled: item.disabled,
                    style: {
                      "width": "100%",
                      "min-width": "100px"
                    },
                    clearable: ""
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(levelData)[item.dataCode], enumItem => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: enumItem.value,
                        label: enumItem.label,
                        value: enumItem.value,
                        disabled: item.disabled
                      }, null, 8, ["label", "value", "disabled"]);
                    }), 128))]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : item.type === 'singleSelect' ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 7,
                    placeholder: "请选择",
                    modelValue: _unref(queryParams)[item.code],
                    "onUpdate:modelValue": $event => _unref(queryParams)[item.code] = $event,
                    disabled: item.disabled,
                    multiple: item.multiple,
                    "collapse-tags": "",
                    "collapse-tags-tooltip": "",
                    clearable: "",
                    style: {
                      "min-width": "100px"
                    }
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.dicCodeData, dicItem => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: dicItem.value + dicItem.label,
                        label: dicItem.label,
                        value: dicItem.value
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "multiple"])) : item.type === 'datePicker' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                    key: 8,
                    modelValue: _unref(queryParams)[item.code],
                    "onUpdate:modelValue": $event => _unref(queryParams)[item.code] = $event,
                    type: "daterange",
                    "value-format": "YYYY-MM-DD",
                    "range-separator": "-",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    disabled: item.disabled,
                    style: {
                      "min-width": "210px"
                    }
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : item.type === 'date' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                    key: 9,
                    modelValue: _unref(queryParams)[item.code],
                    "onUpdate:modelValue": $event => _unref(queryParams)[item.code] = $event,
                    type: "date",
                    "value-format": "YYYY-MM-DD",
                    disabled: item.disabled,
                    style: {
                      "min-width": "100px"
                    }
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : item.type === 'text' ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(item.content), 1)) : item.type === 'yearPicker' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                    key: 11,
                    modelValue: _unref(queryParams)[item.code],
                    "onUpdate:modelValue": $event => _unref(queryParams)[item.code] = $event,
                    type: "year",
                    "value-format": "YYYY",
                    disabled: item.disabled,
                    style: {
                      "min-width": "100px"
                    },
                    onChange: $event => item.method && item.method(_unref(queryParams), _unref(levelData))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])) : _createCommentVNode("", true)]),
                  _: 2
                }, 1032, ["label", "rules", "label-width", "prop"])]),
                _: 2
              }, 1032, ["span"]);
            }), 128)), _createVNode(_component_el_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  size: "default",
                  type: "primary",
                  icon: "Search",
                  onClick: getList,
                  style: {
                    "margin-top": "5px"
                  }
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("查询", -1)]))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.buttons, (item, index) => {
              return _openBlock(), _createBlock(_component_el_button, {
                key: index,
                size: "default",
                type: "primary",
                icon: item.icon,
                style: {
                  "margin-top": "5px"
                },
                onClick: $event => emitMethod(item.key),
                title: item.toolTips == '' || item.toolTips == null || item.toolTips === undefined ? '' : item.toolTips
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                _: 2
              }, 1032, ["icon", "onClick", "title"]);
            }), 128))]),
            _: 3
          })]),
          _: 3
        }, 8, ["model", "label-width"]), [[_vShow, _unref(isShowForm)]])]),
        _: 3
      })) : (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        style: {
          "position": "absolute",
          "right": "10px",
          "bottom": "0"
        },
        size: "default",
        type: "primary",
        icon: 'ZoomIn',
        onClick: changFormStatus
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(searchBtnText)), 1)]),
        _: 1
      }))], 4);
    };
  }
};